import {GetHeaderBulkResponse_NavigationBarSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/service.types';
import {ErrorBoundary} from '@aboutyou/ui-components';
import React, {memo} from 'react';
import {NavigationFlyoutContent} from './NavigationFlyoutContent';

interface NavigationFlyoutContentsProps
  extends GetHeaderBulkResponse_NavigationBarSection {
  activeNavItemIndex: number | undefined;
}

const MemoNavigationFlyoutContent = memo(NavigationFlyoutContent);

export const NavigationFlyoutContents = ({
  activeNavItemIndex,
  items,
}: NavigationFlyoutContentsProps) => {
  return (
    <>
      {items.map((item, index) => (
        <ErrorBoundary
          renderContext={`header_flyout_${item.label.toLowerCase()}`}
          key={`navigationFlyoutContent-${index}`}
        >
          <MemoNavigationFlyoutContent
            flyout={item.flyout}
            isActive={index === activeNavItemIndex}
            testId={`navigationFlyoutContent-${item.label}`}
          />
        </ErrorBoundary>
      ))}
    </>
  );
};
